import React from "react";
import PropTypes from "prop-types";

import { redactedSectionCaller, redactedSectionAgent } from "./Events.module.scss";

const REDACTED_SECTION_BY_SPEAKER = { caller: redactedSectionCaller, agent: redactedSectionAgent };

const RedactedSectionEvent = ({ startTime, endTime, speaker, progressPercent }) => {
  return <div className={REDACTED_SECTION_BY_SPEAKER[speaker]}
    style={{ left: `${progressPercent(startTime)}%`, width: `${progressPercent(endTime - startTime)}%` }}
  />;
};

RedactedSectionEvent.propTypes = {
  startTime: PropTypes.number.isRequired,
  endTime: PropTypes.number.isRequired,
  speaker: PropTypes.string.isRequired,
  progressPercent: PropTypes.func.isRequired
};

export default RedactedSectionEvent;
